import { dropTask } from 'ember-concurrency';
import { eq } from 'tio-ui/utilities';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type Store from '@ember-data/store';
import { t } from 'ember-intl';
import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';
import { PhTrayArrowDown } from 'ember-phosphor-icons';

export interface EligibilityFilesDownloadEligibilityFileSignature {
  Args: {
    legacyId: string;
    companyId: string;
    processId: string;
    fileName: string;
    title: string;
    format: string;
  };
  Element: HTMLElement;
}

export default class EligibilityFilesDownloadEligibilityFileComponent extends Component<EligibilityFilesDownloadEligibilityFileSignature> {
  @service declare store: Store;

  get apiHost() {
    return this.store.adapterFor('application')?.host;
  }

  get headers() {
    const header = this.store.adapterFor('application')?.headers;
    header['Content-Type'] = 'application/vnd.api+json';
    return header;
  }

  downloadEligibilityFile = dropTask(async () => {
    const response = await fetch(
      `${this.apiHost}/eligibility-files/get-download-url/${this.args.processId}/${this.args.companyId}/${this.args.legacyId}`,
      {
        method: 'GET',
        headers: this.headers,
      }
    );
    if (response.ok) {
      const fileUrl = await response.text();
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', this.args.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('Unable to download file due to an error.', response);
    }
  });

  <template>
    {{#if (eq @format "text-button")}}
      <Button
        @intent="primary"
        @label={{t "eligibility_files.download"}}
        {{on "click" this.downloadEligibilityFile.perform}}
      />
    {{else}}
      <Button
        @intent="primary"
        @appearance="outlined"
        title={{@title}}
        {{on "click" this.downloadEligibilityFile.perform}}
        @icon={{PhTrayArrowDown}}
      />
    {{/if}}
  </template>
}
